module.exports = __webpack_public_path__ + "static/media/glasgow.a75c8af7.jpg";